import React from "react";
import { useLocation } from "react-router-dom";

function Pagetitle() {
  const location = useLocation();
  const pageTitles = {
    "/contact": "Contact Us",
  "/desi-cow-ghee":"Our products",
  "/our-story":"About Us",
  "/track-order":"Track order",
  "/reviewus":"Review us",          
  "/login":"Login",          
  "/register":"Register",          
  "/cart":"Cart",        
  "/product-carousel":"Products",          
  "/blog":"Health Care Blogs",          
  "/checkout":"Start checkout",          
  "/blogs":"Blog Detail",                    
  "/our-products":"Our Products",          
  "/all-products":"All Products",          
  "/our-policies":"Our Policies",          
  "/privacy-policy":"Our Policies",          
  "/return-policy":"Our Return Policies",          
  "/shipping-policy":"Our Shipping Policies",          
  "/terms-conditions":"Our Terms & Conditions Policies",          
  "/my-orders":"My Orders",          
  "/my-profile":"My Profile",          
  "/complaint":"Complaint",
  "/not-found":"404 - Page Not Found",
             
  };

  const currentTitle = pageTitles[location.pathname] || "Page Not Found";

  return (
    <div
      className="row pagebgimg py-5"
      style={{ backgroundImage: "url('/assets/img/breadcrumbs.png')" }}
    >
      <h2 className="text-center text-white py-4 fw-bold">{currentTitle}</h2>
    </div>
  );
}

export default Pagetitle;
